function aclShow($animate, aclService): Object {
    return {
        restrict: "A",
        link: (scope, element, attrs) => {
            if (!attrs.thorAclShow) {
                return;
            }

            // Hide element while we're not sure if user is allowed.
            $animate.addClass(element, "ng-hide");

            if (aclService.isAllowed(attrs.thorAclShow)) {
                $animate.removeClass(element, "ng-hide");
            } else {
                element.remove();
            }
        }
    };
}

function aclEnable(aclService): Object {
    return {
        restrict: "A",
        link: (scope, element, attrs) => {
            if (!attrs.thorAclEnable) {
                return;
            }

            // Disable element while we're not sure if user is allowed.
            element.attr("disabled", true);

            if (aclService.isAllowed(attrs.thorAclEnable)) {
                element.removeAttr("disabled");
            } else {
                element.attr("disabled", true);
            }
        }
    };
}

aclShow.$inject = ["$animate", "aclService"];
aclEnable.$inject = ["aclService"];

angular
    .module("thor.core.acl.directive", [])
    .directive("thorAclShow", aclShow)
    .directive("thorAclEnable", aclEnable);
